import IconHOC from '../IconHOC';

import { ReactComponent as PlusIcon } from './plus.svg';

export const Plus = IconHOC(PlusIcon);
